import React from "react";
import useInterval from "../../hooks/useInterval";
import Sprite from "./Sprite";

const AnimatedSprite = ({
    initialFrame = 0,
    isPlaying = true,
    loop = true,
    frameDuration = 300,
    frame = {},
    bounds = {},
    scale = 1,
    ...props
}) => {
    const maxFramesWidth = (bounds.width - bounds.x) / frame.width;
    const maxFramesHeight = (bounds.height - bounds.y) / frame.height;

    const [frameIndex, setFrameIndex] = React.useState(initialFrame);
    const [maxFrames, setMaxFrames] = React.useState(maxFramesWidth * maxFramesHeight);
    const nextFrame = React.useCallback(() => {
        setFrameIndex(frameIndex + 1);
    }, [frameIndex]);
    useInterval(nextFrame, isPlaying ? frameDuration : undefined);

    React.useEffect(() => {
        if (loop && frameIndex === maxFrames) {
            setFrameIndex(0);
        }
    }, [loop, frameIndex, maxFrames]);

    React.useEffect(() => {
        setFrameIndex(0);
        setMaxFrames(maxFramesWidth * maxFramesHeight);
    }, [maxFramesWidth, maxFramesHeight]);

    const spriteData = {
        width: frame.width,
        height: frame.height,
        backgroundWidth: bounds.width,
        backgroundHeight: bounds.height,
        x: frame.width * frameIndex,
        y: 0,
        scale,
    };

    return <Sprite {...spriteData} {...props} />;
};

export default AnimatedSprite;
